import Api from 'src/api/Base'

class PostShelfProductLayout extends Api {
  requestUrl = `/api/ShelfProductLayout`

  method = 'POST'
}

export default PostShelfProductLayout
